import { useState } from 'react'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'

import { useAppSelector } from '~/store'
import { post } from '../../tools/request'

export default function ProcessInsufficientStockModal({ open, onClose, salesFilter }) {
    const { insufficientStockSalesAPIURL } = useAppSelector((state) => state.initial.endpoints)
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)

    const processInsufficientStock = async () => {
        setLoading(true)
        const res = await post(insufficientStockSalesAPIURL, {
            sale_filter: salesFilter,
        })
        setLoading(false)
        if (res.ok) {
            setErrorMessage(null)
            onClose(true)
        } else {
            setErrorMessage(res.error_message)
        }
    }

    return (
        <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
            <DialogTitle>{gettext('Change insufficient stock status to pending')}</DialogTitle>
            <DialogContent>
                <Typography gutterBottom variant="body2">
                    {gettext(
                        'Stock will be deducted from available stock if available. If no stock is available then stock will be added automatically.'
                    )}
                </Typography>
                {errorMessage && (
                    <Typography
                        gutterBottom
                        variant="body2"
                        sx={{ color: (theme) => theme.palette.error[400] }}
                    >
                        {errorMessage}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions sx={{ py: 3, pb: 2, mt: 0 }}>
                <Button color="secondary" onClick={() => onClose(false)}>
                    {gettext('Cancel')}
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    disabled={loading}
                    onClick={processInsufficientStock}
                >
                    {gettext('Change to pending')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
